import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { Auth0Service } from '@lib/auth0';
import { WithDestroy } from '@lib/shared';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends WithDestroy() implements OnInit, OnDestroy {
  constructor(private authService: Auth0Service, private router: Router, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  public logout() {
    const uri = '/' + (this.route.snapshot.params.nmls || '');
    this.authService.logout({
      redirectUri: uri
    });
  }
}
